<template>
    <div class="page-main" :class="{ 'load': load }">
        <a href="#"  @click.prevent="loadClick('Inner page')" class="main-dialog" :class="{ 'map-animation': mapAnimation && !$root.isMobile }">
            <h1 class="main-dialog-h1">Там, где тепло</h1>
            <p class="main-dialog-p">
                В&nbsp;мире есть места, которые, словно тепловая карта,
                пульсируют жаром новых впечатлений. Чтобы вам было легче
                в&nbsp;новом путешествии, мы&nbsp;подобрали 50&nbsp;невероятных мест,
                и&nbsp;узнали о&nbsp;том, как их&nbsp;лучше всего фотографировать.
                А&nbsp;вам лишь останется выложить фотографию в&nbsp;социальную
                сеть и&nbsp;ждать сотни лайков.</p>
            <a class="main-dialog-arrow" href="#" @click.prevent="loadClick('Inner page')">
                <arrow></arrow>
            </a>
        </a>
        <p class="map-text">Кликните на интересующую вас страну на карте или выберите ее из списка</p>
        <div class="main-circles" :class="{ 'map-animation': mapAnimation  }" v-if="!$root.isMobile">
            <div class="map-side-left"></div>
            <a class="map-center" href="#" @click.prevent="loadClick('Inner page')">
                <div class="map">
                    <earth class="earth"></earth>
                </div>
            </a>
            <div class="map-side-right"></div>
        </div>
        <div class="main-circles" :class="{ 'map-animation': mapAnimation && !$root.isMobile }" v-else>
            <div class="map-side-left"></div>
            <div class="map-center" v-if="!load">
                <div class="map">
                    <earth class="earth"></earth>
                </div>
            </div>
            <div class="map-center"
                 :style="{ transform: 'translate('+mapPosition[swiperIndex].left+'%, '+mapPosition[swiperIndex].top+'%) scale(15)' }"
                 v-else>
                <div class="map" @click="linkCountry" :class="mapPosition[swiperIndex].name">
                    <earth class="earth"></earth>
                </div>
            </div>
            <div class="map-side-right"></div>
        </div>
        <div class="menu">
            <p>
                Выбор страны:
            </p>
            <div class="menu-links" v-if="!$root.isMobile">
                <router-link to="/country/germany" class="link-germany" @click="gaSend('Germany')">Германия</router-link>
                <router-link to="/country/greece" class="link-greece" @click="gaSend('Greece')">Греция</router-link>
                <router-link to="/country/israel" class="link-israel" @click="gaSend('Israel')">Израиль</router-link>
                <router-link to="/country/spain" class="link-spain" @click="gaSend('Spain')">Испания</router-link>
                <router-link to="/country/italy" class="link-italy" @click="gaSend('Italy')">Италия</router-link>
                <router-link to="/country/tailandia" class="link-tailandia" @click="gaSend('Tailandia')">Таиланд</router-link>
                <router-link to="/country/turkey" class="link-turkey" @click="gaSend('Turkey')">Турция</router-link>
                <router-link to="/country/france" class="link-france" @click="gaSend('France')">Франция</router-link>
                <router-link to="/country/oae" class="link-oae" @click="gaSend('Oae')">ОАЭ</router-link>
                <router-link to="/country/korea" class="link-korea" @click="gaSend('Korea')">Южная Корея</router-link>
            </div>

            <swiper :options="swiperOptionTop" class="gallery-top" @slideChange="slideChanged" ref="swiperTop" v-else>
                <swiper-slide>
                    <router-link to="/country/germany" class="link-germany" @click="gaSend('Germany')">Германия</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/greece" class="link-greece" @click="gaSend('Greece')">Греция</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/israel" class="link-israel" @click="gaSend('Israel')">Израиль</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/spain" class="link-spain" @click="gaSend('Spain')">Испания</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/italy" class="link-italy" @click="gaSend('Italy')">Италия</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/tailandia" class="link-tailandia" @click="gaSend('Tailandia')">Таиланд</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/turkey" class="link-turkey" @click="gaSend('Turkey')">Турция</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/france" class="link-france" @click="gaSend('France')">Франция</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/oae" class="link-oae" @click="gaSend('Oae')">ОАЭ</router-link>
                </swiper-slide>
                <swiper-slide>
                    <router-link to="/country/korea" class="link-korea" @click="gaSend('Korea')">Южная Корея</router-link>
                </swiper-slide>
            </swiper>
            <div class="swiper-button-prev" slot="button-prev" v-if="$root.isMobile">
                <arrowSlide></arrowSlide>
            </div>
            <div class="swiper-button-next" slot="button-next" v-if="$root.isMobile">
                <arrowSlide></arrowSlide>
            </div>
        </div>

    </div>
</template>

<script>
    import {TweenMax, TweenLite} from 'gsap'
    import {mapGetters} from 'vuex';
    import Helpers from '@/tools/Helpers'

    import flag from '@/assets/svg/flag'
    import earth from '@/assets/svg/map.svg'
    import arrow from '@/assets/svg/arrow.svg'
    import arrowSlide from '@/assets/svg/arrow-slide.svg'
    import router from "../../router/index";

    export default {
        name: 'Main',
        components: {
            earth,
            arrow,
            arrowSlide,
        },
        data() {
            return {
                mapAnimation: false,
                load: false,
                swiperIndex: 0,
                mapPosition: [
                    {
                        top: 70,
                        left: -23,
                        name: 'germany'
                    },
                    {
                        top: 34,
                        left: -72,
                        name: 'greece'
                    },
                    {
                        top: 12,
                        left: -134,
                        name: 'israel'
                    },
                    {
                        top: 35,
                        left: 35,
                        name: 'spain'
                    },
                    {
                        top: 44,
                        left: -30,
                        name: 'italy'
                    },
                    {
                        top: -35,
                        left: -422,
                        name: 'tailandia'
                    },
                    {
                        top: 30,
                        left: -113,
                        name: 'turkey'
                    },
                    {
                        top: 51,
                        left: 11,
                        name: 'france'
                    },
                    {
                        top: -7,
                        left: -217,
                        name: 'oae'
                    },
                    {
                        top: 34,
                        left: -524,
                        name: 'korea'
                    },
                ],
                swiperOptionTop: {
                    slidesPerView: 2,
                    slidesOffsetBefore: -50,
                    centeredSlides: true,
                    allowTouchMove: false,
                    logSwipes: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
            }
        },
        computed: {
            ...mapGetters(['GET_LOAD']),
        },
        methods: {
            gaSend(index) {
                Helpers.ga().send( 'Main page', 'Click', index);
            },
            slideChanged() {
                this.swiperIndex = this.$refs.swiperTop.swiper.activeIndex;
            },
            loadClick(index) {
                Helpers.ga().send( 'Main Page', 'Click', index);
                if (this.GET_LOAD) {
                    this.mapAnimation = true;
                    let self = this;
                    TweenMax.fromTo(".main-dialog", .5, {autoAlpha: 1}, {autoAlpha: 0});
                    if (!this.$root.isMobile) {
                        setTimeout(function () {
                            self.$store.commit('SET_LOAD', false);
                            self.load = true;
                        }, 800)
                    } else {
                        self.$store.commit('SET_LOAD', false);
                        self.load = true;
                    }
                }
            },
            linkCountry() {
                this.$router.push('/country/' + this.mapPosition[this.swiperIndex].name)
            }
        },
        mounted() {
            TweenMax.fromTo(".main-dialog-h1", 1, {autoAlpha: 0}, {autoAlpha: 1, delay: .5});
            TweenMax.fromTo(".main-dialog-p", 1, {autoAlpha: 0}, {autoAlpha: 1, delay: 1});
            TweenMax.fromTo(".main-dialog-arrow svg", 1, {autoAlpha: 0}, {autoAlpha: 1, delay: 1.5});
            let self = this;
            if (!this.$root.isMobile) {
                // france
                document.querySelector('.icon-france').addEventListener('mouseover', function () {
                    document.querySelector('.country-france .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-france .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-france').setAttribute("opacity", ".99");
                    document.querySelector('.link-france').classList.add('hover');
                });
                document.querySelector('.icon-france').addEventListener('mouseout', function () {
                    document.querySelector('.country-france .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-france .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-france').setAttribute("opacity", ".4");
                    document.querySelector('.link-france').classList.remove('hover');
                });

                document.querySelector('.link-france').addEventListener('mouseover', function () {
                    document.querySelector('.country-france .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-france .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-france').setAttribute("opacity", ".99");
                    document.querySelector('.icon-france').classList.add('hover');
                });
                document.querySelector('.link-france').addEventListener('mouseout', function () {
                    document.querySelector('.country-france .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-france .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-france').setAttribute("opacity", ".4");
                    document.querySelector('.icon-france').classList.remove('hover');
                });

                document.querySelector('.icon-france').addEventListener('click', function () {
                    self.$router.push('/country/france');
                    Helpers.ga().send( 'Main page', 'Click', 'France');
                });

                // italy
                document.querySelector('.icon-italy').addEventListener('mouseover', function () {
                    document.querySelector('.country-italy .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy .country-fill3').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy').setAttribute("opacity", "1");
                    document.querySelector('.link-italy').classList.add('hover');
                });
                document.querySelector('.icon-italy').addEventListener('mouseout', function () {
                    document.querySelector('.country-italy .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy .country-fill3').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy').setAttribute("opacity", ".4");
                    document.querySelector('.link-italy').classList.remove('hover');
                });

                document.querySelector('.link-italy').addEventListener('mouseover', function () {
                    document.querySelector('.country-italy .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy .country-fill3').setAttribute("fill", "#00b956");
                    document.querySelector('.country-italy').setAttribute("opacity", "1");
                    document.querySelector('.icon-italy').classList.add('hover');
                });
                document.querySelector('.link-italy').addEventListener('mouseout', function () {
                    document.querySelector('.country-italy .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy .country-fill3').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-italy').setAttribute("opacity", ".4");
                    document.querySelector('.icon-italy').classList.remove('hover');
                });

                document.querySelector('.icon-italy').addEventListener('click', function () {
                    self.$router.push('/country/italy')
                    Helpers.ga().send( 'Main page', 'Click', 'Italy');
                });

                // spain
                document.querySelector('.icon-spain').addEventListener('mouseover', function () {
                    document.querySelector('.country-spain .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-spain').setAttribute("opacity", "1");
                    document.querySelector('.link-spain').classList.add('hover');
                });
                document.querySelector('.icon-spain').addEventListener('mouseout', function () {
                    document.querySelector('.country-spain .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-spain').setAttribute("opacity", ".4");
                    document.querySelector('.link-spain').classList.remove('hover');
                });

                document.querySelector('.link-spain').addEventListener('mouseover', function () {
                    document.querySelector('.country-spain .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-spain').setAttribute("opacity", "1");
                    document.querySelector('.icon-spain').classList.add('hover');
                });
                document.querySelector('.link-spain').addEventListener('mouseout', function () {
                    document.querySelector('.country-spain .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-spain').setAttribute("opacity", ".4");
                    document.querySelector('.icon-spain').classList.remove('hover');
                });
                document.querySelector('.icon-spain').addEventListener('click', function () {
                    self.$router.push('/country/spain')
                    Helpers.ga().send( 'Main page', 'Click', 'Spain');
                });


                // germany
                document.querySelector('.icon-germany').addEventListener('mouseover', function () {
                    document.querySelector('.country-germany .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-germany').setAttribute("opacity", "1");
                    document.querySelector('.link-germany').classList.add('hover');
                });
                document.querySelector('.icon-germany').addEventListener('mouseout', function () {
                    document.querySelector('.country-germany .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-germany').setAttribute("opacity", ".4");
                    document.querySelector('.link-germany').classList.remove('hover');
                });

                document.querySelector('.link-germany').addEventListener('mouseover', function () {
                    document.querySelector('.country-germany .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-germany').setAttribute("opacity", "1");
                    document.querySelector('.icon-germany').classList.add('hover');
                });
                document.querySelector('.link-germany').addEventListener('mouseout', function () {
                    document.querySelector('.country-germany .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-germany').setAttribute("opacity", ".4");
                    document.querySelector('.icon-germany').classList.remove('hover');
                });

                document.querySelector('.icon-germany').addEventListener('click', function () {
                    self.$router.push('/country/germany');
                    Helpers.ga().send( 'Main page', 'Click', 'Germany');
                });

                // oae
                document.querySelector('.icon-oae').addEventListener('mouseover', function () {
                    document.querySelector('.country-oae').setAttribute("fill", "#00b956");
                    document.querySelector('.country-oae').setAttribute("opacity", "1");
                    document.querySelector('.link-oae').classList.add('hover');
                });
                document.querySelector('.icon-oae').addEventListener('mouseout', function () {
                    document.querySelector('.country-oae').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-oae').setAttribute("opacity", ".4");
                    document.querySelector('.link-oae').classList.remove('hover');
                });

                document.querySelector('.link-oae').addEventListener('mouseover', function () {
                    document.querySelector('.country-oae').setAttribute("fill", "#00b956");
                    document.querySelector('.country-oae').setAttribute("opacity", "1");
                    document.querySelector('.icon-oae').classList.add('hover');
                });
                document.querySelector('.link-oae').addEventListener('mouseout', function () {
                    document.querySelector('.country-oae').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-oae').setAttribute("opacity", ".4");
                    document.querySelector('.icon-oae').classList.remove('hover');
                });

                document.querySelector('.icon-oae').addEventListener('click', function () {
                    self.$router.push('/country/oae');
                    Helpers.ga().send( 'Main page', 'Click', 'Oae');
                });

                // greece
                document.querySelector('.icon-greece').addEventListener('mouseover', function () {
                    document.querySelector('.country-greece .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-greece').setAttribute("opacity", "1");
                    document.querySelector('.link-greece').classList.add('hover');
                });
                document.querySelector('.icon-greece').addEventListener('mouseout', function () {
                    document.querySelector('.country-greece .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-greece').setAttribute("opacity", ".4");
                    document.querySelector('.link-greece').classList.remove('hover');
                });

                document.querySelector('.link-greece').addEventListener('mouseover', function () {
                    document.querySelector('.country-greece .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-greece').setAttribute("opacity", "1");
                    document.querySelector('.icon-greece').classList.add('hover');
                });
                document.querySelector('.link-greece').addEventListener('mouseout', function () {
                    document.querySelector('.country-greece .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-greece').setAttribute("opacity", ".4");
                    document.querySelector('.icon-greece').classList.remove('hover');
                });

                document.querySelector('.icon-greece').addEventListener('click', function () {
                    self.$router.push('/country/greece');
                    Helpers.ga().send( 'Main page', 'Click', 'Greece');
                });

                // turkey
                document.querySelector('.icon-turkey').addEventListener('mouseover', function () {
                    document.querySelector('.country-turkey .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-turkey .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-turkey').setAttribute("opacity", "1");
                    document.querySelector('.link-turkey').classList.add('hover');
                });
                document.querySelector('.icon-turkey').addEventListener('mouseout', function () {
                    document.querySelector('.country-turkey .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-turkey .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-turkey').setAttribute("opacity", ".4");
                    document.querySelector('.link-turkey').classList.remove('hover');
                });

                document.querySelector('.link-turkey').addEventListener('mouseover', function () {
                    document.querySelector('.country-turkey .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-turkey .country-fill2').setAttribute("fill", "#00b956");
                    document.querySelector('.country-turkey').setAttribute("opacity", "1");
                    document.querySelector('.icon-turkey').classList.add('hover');

                });
                document.querySelector('.link-turkey').addEventListener('mouseout', function () {
                    document.querySelector('.country-turkey .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-turkey .country-fill2').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-turkey').setAttribute("opacity", ".4");
                    document.querySelector('.icon-turkey').classList.remove('hover');
                });

                document.querySelector('.icon-turkey').addEventListener('click', function () {
                    self.$router.push('/country/turkey');
                    Helpers.ga().send( 'Main page', 'Click', 'Turkey');
                });


                // israel
                document.querySelector('.icon-israel').addEventListener('mouseover', function () {
                    document.querySelector('.country-israel').setAttribute("fill", "#00b956");
                    document.querySelector('.country-israel').setAttribute("opacity", "1");
                    document.querySelector('.link-israel').classList.add('hover');
                });
                document.querySelector('.icon-israel').addEventListener('mouseout', function () {
                    document.querySelector('.country-israel').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-israel').setAttribute("opacity", ".4");
                    document.querySelector('.link-israel').classList.remove('hover');
                });

                document.querySelector('.link-israel').addEventListener('mouseover', function () {
                    document.querySelector('.country-israel').setAttribute("fill", "#00b956");
                    document.querySelector('.country-israel').setAttribute("opacity", "1");
                    document.querySelector('.icon-israel').classList.add('hover');
                });
                document.querySelector('.link-israel').addEventListener('mouseout', function () {
                    document.querySelector('.country-israel').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-israel').setAttribute("opacity", ".4");
                    document.querySelector('.icon-israel').classList.remove('hover');
                });
                document.querySelector('.icon-israel').addEventListener('click', function () {
                    self.$router.push('/country/israel');
                    Helpers.ga().send( 'Main page', 'Click', 'Israel');
                });

                // tailandia
                document.querySelector('.icon-tailandia').addEventListener('mouseover', function () {
                    document.querySelector('.country-tailandia .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-tailandia').setAttribute("opacity", "1");
                    document.querySelector('.link-tailandia').classList.add('hover');
                });
                document.querySelector('.icon-tailandia').addEventListener('mouseout', function () {
                    document.querySelector('.country-tailandia .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-tailandia').setAttribute("opacity", ".4");
                    document.querySelector('.link-tailandia').classList.remove('hover');

                });

                document.querySelector('.link-tailandia').addEventListener('mouseover', function () {
                    document.querySelector('.country-tailandia .country-fill').setAttribute("fill", "#00b956");
                    document.querySelector('.country-tailandia').setAttribute("opacity", "1");
                    document.querySelector('.icon-tailandia').classList.add('hover');
                });
                document.querySelector('.link-tailandia').addEventListener('mouseout', function () {
                    document.querySelector('.country-tailandia .country-fill').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-tailandia').setAttribute("opacity", ".4");
                    document.querySelector('.icon-tailandia').classList.remove('hover');
                });

                document.querySelector('.icon-tailandia').addEventListener('click', function () {
                    self.$router.push('/country/tailandia');
                    Helpers.ga().send( 'Main page', 'Click', 'Tailandia');
                });

                // korea
                document.querySelector('.icon-korea').addEventListener('mouseover', function () {
                    document.querySelector('.country-korea').setAttribute("fill", "#00b956");
                    document.querySelector('.country-korea').setAttribute("opacity", "1");
                    document.querySelector('.link-korea').classList.add('hover');

                });
                document.querySelector('.icon-korea').addEventListener('mouseout', function () {
                    document.querySelector('.country-korea').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-korea').setAttribute("opacity", ".4");
                    document.querySelector('.link-korea').classList.remove('hover');
                });

                document.querySelector('.link-korea').addEventListener('mouseover', function () {
                    document.querySelector('.country-korea').setAttribute("fill", "#00b956");
                    document.querySelector('.country-korea').setAttribute("opacity", "1");
                    document.querySelector('.icon-korea').classList.add('hover');
                });
                document.querySelector('.link-korea').addEventListener('mouseout', function () {
                    document.querySelector('.country-korea').setAttribute("fill", "#ffffff");
                    document.querySelector('.country-korea').setAttribute("opacity", ".4");
                    document.querySelector('.icon-korea').classList.remove('hover');
                });

                document.querySelector('.icon-korea').addEventListener('click', function () {
                    self.$router.push('/country/korea');
                    Helpers.ga().send( 'Main page', 'Click', 'Korea');
                });
            }
//            this.$refs.swiperTop.options.onlyExternal = false;
        },
        created() {
            Helpers.ga().send( 'Main page', 'Load', 'Load Site');
            if (this.GET_LOAD) {
                TweenMax.to(".icon", 0, {autoAlpha: 0});
            } else {
                this.load = true;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?159f4a1e